import React, { useRef } from 'react';
import { Table } from "../common/Table/index.jsx";
import FormattedNumber from "../common/FormattedNumber.jsx";

import {ViewModeValue} from './Grid.jsx';

const SummaryTable = ({rows, dimension, columns, getColumnAggregateValue, calculateAggregateColumnFormula}) => {
    const tableContainer = useRef();
    const [wrapperHeight, setWrapperHeight] = React.useState(40);

    const columnDefs = React.useMemo(
      () => [
        {
          Header: dimension.name,
          accessor: `dim-${dimension.id}`,
          disableSortBy: true,
          Cell: ({ value }) => <ViewModeValue value={value} mapping={Object.fromEntries(dimension.categories.map((c) => [c.category_id, c.category_name]))} />,
          cellText: (value) => {
            return dimension.categories.find((cat) => cat.category_id == value)?.category_name || value
          },
        },
        ...columns.map((c) => ({
          Header: c.label,
          accessor: c.strId,
          disableSortBy: true,
          aggregate: c.formula ? (leafValues, aggregatedValues) => calculateAggregateColumnFormula(c, leafValues) : "sum",
          aggregateValue: c.formula ? getColumnAggregateValue : undefined,
          Aggregated: ({ value }) => (
            <b>
              <FormattedNumber round={3} number={value} />
            </b>
          ),
        })),
      ],
      [dimension]
    );

    const handleResize = (height) => {
      setWrapperHeight(height);
    }

    const groupBy = React.useMemo(() =>  [`dim-${dimension.id}`], [dimension]);


    return <div ref={tableContainer} style={{height: wrapperHeight}}>
      <Table 
        data={rows} 
        columns={columnDefs} 
        isFixedSize
        useGrouping={true}
        useExpand 
        defaultGroupBy={{groupBy: groupBy}}
        alwaysExpanded={false} 
        onClientHeightChange={handleResize}
      />
  </div>
}

export default SummaryTable;